import BigNumber from 'bignumber.js';

export class OnePricer {
  // price: BigNumber

  getPrice() {
    // return this.price;
    return new BigNumber(1).toDecimal();
  }

  getSettledPrice(expiry: number) {
    return new BigNumber(1).toDecimal();
  }
}
